import {createContext} from 'react';

interface ModalDetailsStorage {
  isMobileModal: boolean;
  panelId: string;
  /** True when the host modal wants its content to size to fit; a Panel inside it hugs its content instead of filling. */
  shouldPanelSizeToContent: boolean;
}

export const ModalDetails = createContext<ModalDetailsStorage | null>(null);
